import React from "react";
import {
  Paper,
  Typography,
  CircularProgress,
  Divider,
} from "@material-ui/core";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import { getPost, getPostBySearch } from "../../redux/action/postAction";
import CommentSection from "./CommentSection";

import useStyles from "./styles";

const PostDetails = () => {
  const { post, posts, isLoading } = useSelector((state) => state.posts);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const { id } = useParams();

  console.log(post);

  React.useEffect(() => {
    dispatch(getPost(id));
  }, [id]);

  React.useEffect(() => {
    dispatch(
      getPostBySearch({ search: "none", tagSearch: post?.tags.join(",") })
    );
  }, [post]);

  if (!post) return null;

  if (isLoading) {
    return (
      <Paper className={classes.loadingPaper} elevation={6}>
        <CircularProgress size="5em" />
        <h3>Loading...</h3>
      </Paper>
    );
  }

  const recommendedPost = posts.filter(({ _id }) => _id !== post?._id);

  console.log("RecommendedPost", recommendedPost);

  return (
    <Paper style={{ padding: "20px", borderRadius: "15px" }}>
      <div className={classes.card}>
        <div className={classes.section}>
          <Typography variant="h3" component="h2">
            {post?.title}
          </Typography>
          <Typography
            gutterBottom
            variant="h6"
            color="textSecondary"
            component="h2"
          >
            {post?.tags.map((tag) => `#${tag}`)}
          </Typography>
          <Typography gutterBottom variant="body1" component="p">
            {post.message}
          </Typography>
          <Typography variant="h6">Created by: {post?.name}</Typography>
          <Typography variant="body1">
            {moment(post.createdAt).fromNow()}
          </Typography>
          <Divider style={{ margin: "20px 0" }} />
          <Typography variant="body1">
            <strong>Realtime Chat - coming soon!</strong>
          </Typography>
          <Divider style={{ margin: "20px 0" }} />
          <CommentSection post={post} />
          <Divider style={{ margin: "20px 0" }} />
        </div>
        <div className={classes.imageSection}>
          <img
            className={classes.media}
            src={
              post.selectedFile ||
              "https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png"
            }
            alt={post.title}
          />
        </div>
      </div>
      {recommendedPost.length && (
        <div className={classes.section}>
          <Typography gutterBottom variant="h5">
            You might also like:--
          </Typography>
          <Divider />
          <div className={classes.recommendedPosts}>
            {recommendedPost.map(
              ({ title, message, name, likes, selectedFile, _id }) => (
                <div
                  style={{
                    margin: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(`/posts/${_id}`)}
                  key={_id}
                >
                  <Typography variant="h6">{title}</Typography>
                  <Typography variant="subtitle2">{message}</Typography>
                  <Typography variant="subtitle2">{name}</Typography>
                  <Typography variant="subtitle1">{`Likes: ${likes.length}`}</Typography>
                  <img src={selectedFile} alt="icon" width="200px" />
                </div>
              )
            )}
          </div>
        </div>
      )}
    </Paper>
  );
};

export default PostDetails;
